var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindingAJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.05 3.6a.3.3 0 0 0 .26.54 6.88 6.88 0 0 1 4.76.54c2.27 1 2 2 2.57 1.66a.35.35 0 0 0 .12-.47A5.79 5.79 0 0 0 8.05 3.6Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 16a.34.34 0 1 0-.53.43 29.22 29.22 0 0 1 3.26 4.29c.26.62.63 1.55.06 1.91-1.77 1.16-4.83-3-6.32-4.8 7.85-6 5.26-15.8-3-17.65A11 11 0 0 0 4 2.53a9.79 9.79 0 0 0 .12 15.53 10.14 10.14 0 0 0 2.14 1.29 10 10 0 0 0 3.49.53.3.3 0 0 0 0-.6 9.78 9.78 0 0 1-3.19-.54 9.1 9.1 0 0 1-2-1.25 8.9 8.9 0 0 1 .18-14.08 10 10 0 0 1 8-2.09c7 1.47 9.7 9.58 3.57 15.25A11.41 11.41 0 0 1 12.53 19a.34.34 0 0 0 .22.64 10 10 0 0 0 2.72-1.41c1.52 2.1 3.2 4.72 5 5.54 1.5.69 3.24 0 3.29-1.53.07-2.5-3.56-5.4-4.26-6.24Z",
    fill: "#82e1f2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 8.65c.15-.22.11-.38 0-.47a.3.3 0 0 0-.25-.1 27.34 27.34 0 0 0-4.06.81c-.32.06-.75.74 1 .73a4.77 4.77 0 0 0 1.14-.11c0 .61.06 2.69-.56 2.92a.47.47 0 0 1-.4 0 1.1 1.1 0 0 1-.54-.62c-.12-.46-1.11-.39-.43.81.82 1.45 2.86 1 3-1a8.1 8.1 0 0 0-.4-2.32l.38-.12a6.74 6.74 0 0 0 1.12-.53Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.94 8.19a2 2 0 0 0-2.25 1 4.36 4.36 0 0 0-.14 3.06 1.59 1.59 0 0 0 1.84 1.1.34.34 0 1 0-.07-.68c-1.27 0-1.19-1.9-.61-2.95a1.05 1.05 0 0 1 .84-.47c.88.29 1 1.93.72 2.79a.3.3 0 1 0 .55.24c.67-1.28.55-3.48-.88-4.09Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9 7.92a1.42 1.42 0 0 0-.73.43c-.34.36-.35 1.69-.41 2.57s-.17 2.1.55 2.46a5.06 5.06 0 0 0 2.64.3 1.78 1.78 0 0 0 .23-3.13c1.37-1.07.32-3.22-2.28-2.63Zm.77 4.71a6 6 0 0 1-.89-.13 2.24 2.24 0 0 1-.2-1.08c.18.19 2.37-.45 2.27.63-.06.77-.55.65-1.18.58Zm1-2.86a5.12 5.12 0 0 1-2.08.61l0-1a1.33 1.33 0 0 1 .57-.85c1.42-.12 2.18.71 1.5 1.24Z",
    fill: "#00b1cc",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindingAJob);
export default __webpack_public_path__ + "static/media/finding-a-job.61adf75e9ea2da99fd056c46de92d8fa.svg";
export { ForwardRef as ReactComponent };